import { ChatEvents } from './chatEvents';

const EventBus = {
  on<T = any>(event: ChatEvents, callback: (data: T) => void): EventListener {
    const eventListener = (e: CustomEventInit) => {
      callback(e.detail);
    };
    document.addEventListener(event, eventListener);
    return eventListener;
  },

  dispatch<T = any>(event: ChatEvents, data?: T): void {
    document.dispatchEvent(new CustomEvent(event, { detail: data }));
  },

  off(event: ChatEvents, callback: EventListener): void {
    document.removeEventListener(event, callback);
  },

  once<T = any>(event: ChatEvents, callback: (data: T) => void): void {
    const eventListener = (e: CustomEventInit) => {
      callback(e.detail);
      document.removeEventListener(event, eventListener);
    };
    document.addEventListener(event, eventListener);
  }
};

export default EventBus;
